export default {
  data() {},
  methods: {
    async register() {
      let url = "/user/register";
      let data = this.$data;
      try {
        let res = await this.$post(url, data);
        this.$router.push("/login");
      } catch (error) {
        this.$fail(error);
      }
    }
  }
};
